import React, { useEffect } from 'react';
import { Box, Typography, Button, Grid, Paper, Divider } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { OpenInNew, ArrowBackIos, PlayCircleFilledOutlined } from '@material-ui/icons';
import { AcademyiaData } from 'services/dataService/index';
import { toast } from 'react-toastify';
import Interweave from 'interweave';
import { useStyles } from './styles';


const ToolPage = () => {
    const classes = useStyles();
    const { t } = useTranslation(['tables', 'button']);
    const [academy, setAcademy] = React.useState();
    const [urlVideo, setUrlVideo] = React.useState('');
    const { id } = useParams();
    const history = useHistory();
    const loadAcademyIa = async () => {
        try {
            const response = await AcademyiaData.getAcademyIaById(id);
            setAcademy(response?.data);

        } catch (error) {
            toast.error(t('toastify:commons.toast_error_api'));
        }
    };

    useEffect(() => {
        loadAcademyIa();
    }, []);

    function getYoutubeEmbedUrl(url) {
        try {
            const urlObj = new URL(url);
            if (urlObj.hostname.includes('youtube.com')) {
                const videoId = urlObj.searchParams.get('v');
                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }
            } else if (urlObj.hostname === 'youtu.be') {
                const videoId = urlObj.pathname.slice(1);
                return `https://www.youtube.com/embed/${videoId}`;
            }
        } catch {
            return null;
        }
        return null;
    }

    const embedUrl = getYoutubeEmbedUrl(academy?.url_video);


    return (
        <Box className={classes.root}>
            <Grid item md="auto" xs={12}>
                <Box
                    onClick={() => history.push('/dashboard?tab=1')}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        fontWeight: 500,
                        userSelect: 'none',
                        textDecoration: 'none',
                        marginBottom: 10,
                    }}
                >
                    <ArrowBackIos style={{ marginRight: 3, fontSize: 14 }} />
                    {t('button:commons.btn_back')}
                </Box>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12} md={8}>
                    <Grid item xs={12} md={12}>
                        <Box className={classes.imageWrapper}>
                            <img
                                src={academy?.card?.url}
                                alt="Background"
                                className={classes.bannerImage}
                            />
                            <Box className={classes.overlayContent}>
                                <div className={classes.categoryTag}>{academy?.categories?.name}</div>
                                <Typography variant="h5" className={classes.title}>{academy?.name}</Typography>
                                <Typography variant="body1" style={{ color: '#fff' }} className={classes.description}>
                                    {academy?.description}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>

                    <Box className={classes.section}>
                        <Paper style={{ height: 150, maxHeight: 150, overflow: 'auto' }} className={classes.card}>
                            <Typography className={classes.subtitle} variant="h5" gutterBottom>Sobre a ferramenta</Typography>
                            <Typography >
                                {academy?.about}
                            </Typography>
                        </Paper>
                    </Box>

                    <Box className={classes.section}>
                        <Paper className={classes.card}>
                            <Typography className={classes.subtitle} variant="h5" gutterBottom>Exemplos práticos de uso</Typography>
                            <div className={classes.customHtmlContainer}>
                                <Interweave content={`${academy?.examples}`} />
                            </div>
                        </Paper>
                    </Box>

                    <Box className={classes.section}>
                        <Paper className={classes.card}>
                            <Typography className={classes.subtitle} variant="h5" gutterBottom>Vídeo tutorial</Typography>
                            <div style={{ borderRadius: '8px', overflow: 'hidden' }} className={classes.tutorialVideo}>
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={embedUrl}
                                    title="Vídeo Tutorial"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </Paper>
                    </Box>
                </Grid>

                {/* Acessar Ferramenta */}
                <Grid item xs={12} md={4}>
                    <Box className={classes.accessBox}>
                        <Typography className={classes.subtitle} variant="h6" gutterBottom>Acessar ferramenta</Typography>
                        <Typography variant="body2">
                            Clique no botão abaixo para acessar diretamente a ferramenta {academy?.name} e começar a utilizar.
                        </Typography>
                        <a
                            href={academy?.url_tool}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.link}
                            onClick={() => {
                                if (window.gtag) {
                                    window.gtag('event', 'click_academy_tool', {
                                        event_category: 'Academy',
                                        event_label: academy?.name || 'Nome não disponível',
                                        value: 1,
                                    });
                                    console.log('Evento GA: Click no botão acessar', academy?.name);
                                }
                            }}
                        >
                            <Button variant="contained" color="primary" fullWidth className={classes.button}>
                                Acessar {academy?.name}
                                <OpenInNew className={classes.icon} />
                            </Button>
                        </a>

                        <Divider style={{ margin: '16px 0' }} />

                        <Box mb={3}>
                            <Typography variant="body2"><strong>Categoria</strong> </Typography>
                            <Typography variant="body2"> {academy?.categories?.name}</Typography>
                        </Box>
                        <Typography variant="body2"><strong>Nível de complexidade:</strong></Typography>
                        <Box display="flex" mt={2}>
                            {Array.from({ length: 5 }).map((_, index) => (
                                <Box
                                    key={index}
                                    width={20}
                                    height={6}
                                    bgcolor={index < academy?.difficulty ? '#0056d2' : '#aaa'}
                                    borderRadius={4}
                                    mr={index < 4 ? 0.5 : 0}
                                />
                            ))}
                        </Box>
                        <Box mt={2}>
                            <Typography style={{marginTop: 20}}className={classes.subtitle} variant="h5">
                                Material complementar
                            </Typography>
                            <Typography variant="h6" color="primary" component="a" href="#" display="block"
                                onClick={() => {
                                    if (window.gtag) {
                                        window.gtag('event', 'click_material_complementar', {
                                            event_category: 'Academy',
                                            event_label: 'Material Complementar 1',
                                        });
                                    }
                                }}
                            >
                                <Interweave content={`${academy?.supplementary_material_1}`} />
                            </Typography>

                            <Typography variant="h6" color="primary" component="a" href="#" display="block"
                                onClick={() => {
                                    if (window.gtag) {
                                        window.gtag('event', 'click_material_complementar', {
                                            event_category: 'Academy',
                                            event_label: 'Material Complementar 2',
                                        });
                                    }
                                }}
                            >
                                <Interweave content={`${academy?.supplementary_material_2}`} />
                            </Typography>

                            <Typography variant="h6" color="primary" component="a" href="#" display="block"
                                onClick={() => {
                                    if (window.gtag) {
                                        window.gtag('event', 'click_material_complementar', {
                                            event_category: 'Academy',
                                            event_label: 'Material Complementar 3',
                                        });
                                    }
                                }}
                            >
                                <Interweave content={`${academy?.supplementary_material_3}`} />
                            </Typography>

                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ToolPage;
